export default "__VITE_ASSET__0YqusCbs__"